"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIMultiColumnGroup;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

function UIMultiColumnGroup(props) {
  var children = props.children,
      className = props.className,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "className"]);
  return _react.default.createElement("div", (0, _extends2.default)({}, other, {
    className: (0, _classnames.default)('private-multicolumn__group', className)
  }), children);
}

UIMultiColumnGroup.displayName = 'UIMultiColumnGroup';
UIMultiColumnGroup.propTypes = {
  children: _propTypes.default.node
};
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/layout/UIMultiColumnGroup.js
// module id = 844
// module chunks = 5 6